export default {
  items: [
    {
      name: "CPSP", //主页
      url: "/dashboard",
      icon: "icon-home"
      // badge: {
      //   variant: 'primary',
      //   text: 'NEW'
      // }
    },
    {
      title: true,
      name: "base_data", //基础数据
      variant: "info",
      class: "",
      wrapper: {
        element: "",
        attributes: {}
      }
    },
    {
      name: "system_setting", //系统管理
      url: "/system",
      icon: "iconfont icon-system",
      children: [
        {
          name: "user_manage", //用户管理
          url: "/system/UserManage",
          icon: "iconfont icon-user",
          class: "ml-2"
        },
        {
          name: "custmer_bind", //客户绑定
          url: "/system/CustmerBind",
          icon: "fa fa-chain",
          class: "ml-2"
        },
        // {
        //   name: "部门管理", //部门管理
        //   url: "/system/DepartmentManage",
        //   icon: "iconfont icon-department"
        // },
        {
          name: "privilege_manage", //权限管理
          url: "/system/PropertyManage",
          icon: "iconfont icon-property"
        },
        // {
        //   name: "privilege_manage", //权限管理
        //   url: "/system/PropertyManageTest",
        //   icon: "iconfont icon-property"
        // },
        // {
        //   name: "privilege_manage", //角色权限
        //   url: "/system/RolePropertyTest",
        //   icon: "iconfont icon-property"
        // },

        {
          name: "role_manage", //角色管理
          url: "/system/RoleManage",
          icon: "iconfont icon-role"
        },
        // {
        //   name: "role_privilege_setting", //角色权限分配
        //   url: "/system/RolePropertyManage",
        //   icon: "iconfont icon-role-property"
        // },
        {
          name: "log_manage", //日志管理
          url: "/system/LogManage",
          icon: "iconfont icon-log"
        },
        // {
        //   name: "notify", //通知管理
        //   url: "/system/NotifyManage",
        //   icon: "iconfont icon-notify"
        // },
        {
          name: "external_user_setting", //外部用户登录设置
          url: "/system/ExternalUserSetting",
          icon: "iconfont icon-customer"
        },
        {
          name: "ApproveManage", //审批流管理
          url: "/system/ApproveManage",
          icon: "iconfont icon-saleorder_approved"
        },
        {
          name: "system_common_setting", //系统设置
          url: "/system/SystemSetting",
          icon: "iconfont icon-system-setting"
        }
      ]
    },
    {
      name: "base_data", //基础资料
      url: "/base",
      icon: "iconfont icon-base-data",
      children: [
        {
          name: "CompanyInfo", //工厂
          url: "/base/CompanyInfo",
          icon: "iconfont icon-unit"
        },
        {
          name: "CustTable", //客户档案
          url: "/base/CustTableMain",
          icon: "iconfont icon-customer"
        },
        {
          name: "VendTable", //供应商档案
          url: "/base/VendTableMain",
          icon: "iconfont icon-supplier"
        },
        {
          name: "InventTable", //物料档案
          url: "/base/InventTableMain",
          icon: "iconfont icon-material"
        },
        {
          name: "PriceDiscTable", //价格协议
          url: "/base/PriceDiscTable",
          icon: "iconfont icon-agreement"
        },
        {
          name: "Currency", //币种
          url: "/base/Currency",
          icon: "iconfont icon-currency"
        },
        {
          name: "ExchRate", //汇率
          url: "/base/ExchRate",
          icon: "iconfont icon-currency2"
        },
        {
          name: "SalesPool", //订单池
          url: "/base/SaleOrderPool",
          icon: "iconfont icon-saleorder-pool"
        },
        {
          name: "ForecastModel", //预测模型
          url: "/base/ForecastModel",
          icon: "iconfont icon-report4"
        },
        {
          name: "TaxGroupHeading", //税组档案
          url: "/base/Tax",
          icon: "iconfont icon-tax"
        },
        {
          name: "UnitOfMeasure", //单位
          url: "/base/Unit",
          icon: "iconfont icon-unit"
        },
        {
          name: "InventLocation", //仓库
          url: "/base/InventLocation",
          icon: "iconfont icon-warehouse"
        },
        {
          name: "HcmWorker", //工作人员
          url: "/base/Worker",
          icon: "iconfont icon-worker"
        },
        {
          name: "ProductPartsTBL", //部件
          url: "/base/ProductPartsTBL",
          icon: "iconfont icon-bujian"
        },
        {
          name: "WrkCtrTable", //资源
          url: "/base/WrkCtrTable",
          icon: "iconfont icon-ziyuan"
        },
        {
          name: "TECRouteTypeTBL", //工序类型
          url: "/base/TECRouteTypeTBL",
          icon: "iconfont icon-route-type"
        },
        {
          name: "TECColorGroupTBL", //色组
          url: "/base/TECColorGroupTBL",
          icon: "iconfont icon-color-group"
        },
        {
          name: "TECRouteSpoilageStdTBL", //加放
          url: "/base/TECRouteSpoilageStdTBL",
          icon: "iconfont icon-jiafang"
        },
        {
          name: "RouteOprTable", //工序档案
          url: "/base/RouteOprTable",
          icon: "iconfont icon-routedangan"
        },
        {
          name: "ProductPartsType", //盒型类别管理
          url: "/base/ProductPartsType",
          icon: "iconfont icon-box-type"
        },
        {
          name: "ElectricityPrices", //电价档案
          url: "/base/ElectricityPrices",
          icon: "iconfont icon-dianjiaxinxi"
        },
        {
          name: "CostItems", //成本项档案
          url: "/base/CostItems",
          icon: "iconfont icon-bangongshichengben"
        },
        {
          name: "SpoilageTypeRatio", //加放类型
          url: "/base/SpoilageTypeRatio",
          icon: "iconfont icon-jiafangleibie"
        },
        {
          name: "ItemType", //物料类型
          url: "/base/ItemType",
          icon: "iconfont icon-ziyuan"
        },
        {
          name: "ProcessResources", //工序资源
          url: "/base/ProcessResources",
          icon: "iconfont icon-ziyuan"
        },

      ]
    },
    {
      title: true,
      name: "menu", //业务数据
      variant: "info",
      class: "",
      wrapper: {
        element: "",
        attributes: {}
      }
    },
    {
      name: "plant_sales_quote", //销售报价管理
      url: "/sq/",
      icon: "iconfont icon-xiaoshoubaojiaguanli",
      children: [
        // {
        //   name: "InventPrice", //物料价格
        //   url: "/sq/InventPrice",
        //   icon: "iconfont icon-sale-order"
        // },
        {
          name: "Route", //工艺路线
          url: "/sq/Route",
          icon: "iconfont icon-route"
        },
        {
          name: "RouteVersion", //工艺路线版本
          url: "/sq/RouteVersion",
          icon: "iconfont icon-route-data"
        },
        {
          name: "InventBom", //物料bom
          url: "/sq/InventBom",
          icon: "iconfont icon-bom"
        },
        {
          name: "InventBomVersion", //物料bom版本
          url: "/sq/InventBomVersion",
          icon: "iconfont icon-bom-version"
        },
        {
          name: "InventBomRoute", //物料bom工艺关系
          url: "/sq/InventBomRoute",
          icon: "iconfont icon-bom-route-relation"
        },
        {
          name: "QuotationTask", //报价任务
          url: "/sq/QuotationTask",
          icon: "iconfont icon-quote-apply-order"
        },
        {
          name: "QuotationTaskHandle", //报价任务处理
          url: "/sq/QuotationTaskHandle",
          icon: "iconfont icon-quote-apply-handle"
        },
        {
          name: "InventBomCost", //报价试算
          url: "/sq/InventBomCost",
          icon: "iconfont icon-quote-cacl-try"
        },
        {
          name: "CostCacl", //报价核算
          url: "/sq/CostCacl",
          icon: "iconfont icon-quote-cacl"
        },
        {
          name: "QTHDistribution", //主计划管理
          url: "/sq/QTHDistribution",
          icon: "iconfont icon-quote-apply-distribut"
        },
        {
          name: "QTHDistributionProofing", //打样分配
          url: "/sq/QTHDistributionProofing",
          icon: "iconfont icon-quote-apply-distribut"
        },
        {
          name: "QuotationOrderConfirm", //加权确认
          url: "/sq/QuotationOrderConfirm",
          icon: "iconfont icon-quote-weighted-cost-confirm"
        },
        {
          name: "QuotationOrder", //报价单
          url: "/sq/QuotationOrder",
          icon: "iconfont icon-quote-order"
        },
        {
          name: "QuotationOrderProofing", //打样报价单
          url: "/sq/QuotationOrderProofing",
          icon: "iconfont icon-quote-order"
        },
        {
          name: "TempQuotation", //临时报价
          url: "/sq/TempQuotation",
          icon: "iconfont icon-quote-order",
        },
        {
          name: "TempQuotationItem", //临时报价物料管理
          url: "/sq/TempQuotationItem",
          icon: "iconfont icon-quote-order"
        },
      ]
    },
    {
      name: "sales_order_manage", //销售订单管理
      url: "/sd/",
      icon: "iconfont icon-sale-order",
      children: [
        {
          name: "vend_purchase_quote", //内部供应商采购报价
          url: "/sd/VendPurchaseQuote",
          icon: "iconfont icon-sale-offer"
        },
        {
          name: "vend_purchase_quote_out", //外部供应商采购报价
          url: "/sd/VendPurchaseQuoteOut",
          icon: "iconfont icon-sale-offer2"
        },
        {
          name: "vend_initial_quote", //供应商初始报价
          url: "/sd/VendInitialQuote",
          icon: "iconfont icon-sale-offer2"
        },

        {
          name: "SalesTable", //销售订单池
          url: "/sd/SalesOrder",
          icon: "iconfont icon-sale-order"
        },
        // {
        //   name: "sales_order_dispatch", //订单派发
        //   url: "/sd/saleOrderDispatch",
        //   icon: "iconfont icon-dispatch2"
        // },
        // {
        //   name: "sales_order_prediction", //订单预测
        //   url: "/sd/OrderForecast",
        //   icon: "iconfont icon-dispatch"
        // },
        // {

        {
          name: "sales_order_dispatch", //订单派发
          url: "/sd/saleOrderDispatch",
          icon: "iconfont icon-dispatch2"
        },
        {
          name: "sales_order_tracking", //订单跟踪
          url: "/sd/SOTracking",
          icon: "iconfont icon-tracking"
        },
        {
          name: "sales_order_implementation", //销售订单审批执行情况
          url: "/sd/SOImplementation",
          icon: "iconfont icon-tracking"
        }
      ]
    },
    {
      name: "prediction_order_manage", //预测订单管理
      url: "/sdr/",
      icon: "iconfont icon-dispatch",
      children: [
        {
          name: "sales_order_prediction", //订单预测
          url: "/sdr/OrderForecast",
          icon: "iconfont icon-dispatch"
        },
        {
          name: "sales_order_prediction_dispatch", //预测派发
          url: "/sdr/OrderForecastDispatch",
          icon: "iconfont icon-report4"
        },
        {
          name: "DeliveryPlan", //预测交货计划
          url: "/sdr/ForecastDeliveryPlan",
          icon: "iconfont icon-delivery"
        }
        // {
        //   name: "NetDemandPlan", //净需求分析
        //   url: "/sd/NetDemandPlan",
        //   icon: "iconfont icon-fenxi"
        // },
        // {
        //   name: "SafetyStock", //安全库存
        //   url: "/sd/SafetyStock",
        //   icon: "iconfont icon-dianquankucunyujing"
        // },
        // {
        //   name: "SalemanForecast", //销售员预测
        //   url: "/sd/SalemanForecast",
        //   icon: "iconfont icon-dianquankucunyujing"
        // },
      ]
    },
    {
      name: "purchase_order_manage", //采购订单管理
      url: "/mm/",
      icon: "iconfont icon-purchase-manage",
      children: [
        {
          name: "ConsultQuoteApplication", //询价申请
          url: "/mm/ConsultQuoteApplication",
          icon: "iconfont icon-purchase"
        },
        {
          name: "ConsultQuote", //询价单
          url: "/mm/ConsultQuote",
          icon: "iconfont icon-purchase"
        },
        {
          name: "PurchTable", //采购订单池
          url: "/mm/PurchaseOrder",
          icon: "iconfont icon-purchase"
        },
        {
          name: "PurchaseLineReturn", //采购订单跟踪
          url: "/mm/PurchaseLineReturn",
          icon: "iconfont icon-report4"
        },
        {
          name: "PurchImplementation", //采购未执行订单
          url: "/mm/PurchImplementation",
          icon: "iconfont icon-report4"
        },
        {
          name: "DeliveryPlan", //交期计划
          url: "/mm/DeliveryPlan",
          icon: "iconfont icon-plan"
        },
        {
          name: "purchase_order_assess", //采购订单评价
          url: "/mm/saleOrderPurchaseRate",
          icon: "iconfont icon-rate"
        },
        {
          name: "supplier_assess", //供应商评价
          url: "/mm/SupplierRate",
          icon: "iconfont icon-supplier-rate"
        }
      ]
    },

    {
      name: "sales_order_approved", //审批记录
      url: "/sda/ApprovedLog",
      icon: "iconfont icon-saleorder_approved"
    },
    {
      name: "customer_credit_manage", //信用额度维护
      url: "/fi/CustomerCredit",
      icon: "iconfont icon-credit"
    },
    {
      name: "production_capacity_manage", //产能管理
      url: "/fi/ProductionCapacity",
      icon: "iconfont icon-capacity"
    },
    {
      name: "InventSum", //实时库存
      url: "/wm/InventSum",
      icon: "iconfont icon-inventory"
    },
    // {
    //   name: "测试列设置", //测试列设置
    //   url: "/test/TestFieldSetting",
    //   icon: "iconfont icon-inventory",
    // },
    // {
    //   name: "测试表格", //测试表格
    //   url: "/test/TestTable3",
    //   icon: "iconfont icon-inventory",
    // },
    // {
    //   name: "审批流测试", //
    //   url: "/test/testapproved",
    //   icon: "iconfont icon-inventory",
    // },
    // {
    //   name: "颜色配比", //颜色配比
    //   url: "/colorTest",
    //   icon: "fa fa-dashboard"
    // },
    {
      title: true,
      name: "report", //统计分析
      class: "",
      variant: "info",
      wrapper: {
        element: "",
        attributes: {}
      }
    }
  ]
}
